export default {
  institution: {
    tabs: {
      info: "Información general",
      general_info: "Información general",
      stats: "Estadísticas",
    },
    list: "Acceder a la lista de centros",
    dashboardLink: "Acceder al panel de control del centro",
    active: "Activo",
    archived: "Archivado",
    training_active: "Activa",
    training_archived: "Archivada",
    view: "Ver",
    view_training: ({ named }) => `Ver la formación ${named("name")}`,
    no_trainings: "Sin formación",
    avatar_alt: ({ named }) => `Logotipo de ${named("name")}`,
    avatar_initials_alt: ({ named }) => `Iniciales de ${named("name")}`,
    fields: {
      logo: "Logotipo",
      name: "Nombre",
      siret: "SIRET",
      code_uai: "Código UAI",
      email: "Correo electrónico",
      phone: "Teléfono",
      address: "Dirección",
      url: "Sitio web",
      account_number: "Número de cuenta",
      status: "Estado",
    },
    components: {
      title: "Componentes",
    },
    contacts: {
      title: "Contactos",
      empty: "Sin contacto asociado",
      unknown_role: "Contacto",
      account_active: "Cuenta activa",
      account_inactive: "Cuenta inactiva",
    },
    stats: {
      coming_soon: "Próximamente disponible",
      export_all_excel: "Exportar todo — Excel",
      export_in_progress: "Exportación en curso — recibirá una notificación cuando esté lista",
      export_failed: "La exportación ha fallado.",
      level: {
        danger: "Nivel bajo",
        warning: "Nivel medio",
        success: "Buen nivel",
      },
      calculation_note:
        "<strong>Cálculo de estadísticas</strong>: tasas calculadas sobre los cuestionarios publicados y no archivados." +
        " Un trinomio está completo cuando los 3 perfiles (aprendiz, tutor, responsable pedagógico) tienen acceso al cuaderno.",
      table: {
        caption: "Estadísticas por formación",
        training: "Formación",
        questionnaires: "Cuestionarios",
        skills: "Competencias",
        connections: "Conexiones",
        triads: "Trinomios",
      },
      indicators: {
        questionnaire_fill_rate: "Tasa de finalización de cuestionarios",
        skill_fill_rate: "Tasa de finalización de competencias",
        user_connection_rate: "Tasa de conexión de usuarios",
        completed_triads_rate: "Tasa de trinomios completados",
      },
      subcounts: {
        promotions: "promoción(es)",
        active_users: "usuarios activos",
        triads: "trinomio(s)",
      },
    },
    key_figures: {
      title: "Cifras clave",
      current_year: ({ named }) => `Año en curso ${named("start")}/${named("end")}`,
      tooltip: "Calculado sobre las promociones que incluyen el año en curso",
    },
    trainings_count: ({ plural }) => plural(["formación", "formaciones"]),
    promotions_count: ({ plural }) => plural(["promoción", "promociones"]),
    apprentices_count: ({ plural }) => plural(["aprendiz", "aprendices"]),
    active_trainings_count: ({ plural }) => plural(["formación activa", "formaciones activas"]),
    current_promotions_count: ({ plural }) => plural(["promoción en curso", "promociones en curso"]),
    tutors_count: ({ plural }) => plural(["tutor de empresa", "tutores de empresa"]),
  },
};
